<template>
	<div class="col-lg-8">
		<div class="tile">
			<p><em></em></p>
			<h4>Зарегистрированные обращения</h4>
		</div>
		<div class="tile">
			<div>
				Фильтры
			</div>

			<div class="conversion__filter-elem" v-for="filter in filters.filter(x => x.name)" :key="filter.id">
				<div class="col-xs-6 col-sm-4">
					<label :for="filter.id">{{ filter.name }}</label>
				</div>
				<div class="col-xs-12 col-sm-8 conversion__filter-elems">
					<div class=".conversion__filter-input">
						<input :id="filter.id" v-model="filter.value" />
					</div>
				</div>
			</div>

			<div class="conversion__filter-elem">
				<div class="col-xs-6 col-sm-4">
					<label class="text" for="zone">
						Получатель
					</label>
				</div>
				<div class="col-xs-12 col-sm-8 conversion__filter-elems">
					<select v-model="filters[7].value" id="zone">
						<option disabled value="">Выбрать из списка</option>
						<option v-for="item in zones" :key="item.id" :value="item.id">
							{{ item.name }}
						</option>
					</select>
				</div>
			</div>

			<div class="conversion__filter-elem">
				<div class="col-xs-6 col-sm-4">
					<label class="text" for="status">
						Состояние
					</label>
				</div>
				<div class="col-xs-12 col-sm-8 conversion__filter-elems">
					<select v-model="filters[10].value" id="status">
						<option disabled value="">Выбрать из списка</option>
						<option v-for="item in status_types" :key="item.id" :value="item.id">
							{{ item.name }}
						</option>
					</select>
				</div>
			</div>


			<div class="conversion__filter-elem">
				<div class="col-xs-6 col-sm-4">
					<input type="radio" id="reg_true" name="created" value="true"
						v-model="filters.find(x => x.id === 'created_by_registrar').value" />
					<label for="reg_true">От регистраторов</label>
				</div>
				<div class="col-xs-6 col-sm-4">
					<input type="radio" id="reg_false" name="created" value="false"
						v-model="filters.find(x => x.id === 'created_by_registrar').value" />
					<label for="reg_false">Интернет-приёмная</label>
				</div>
			</div>

			<div class="conversion__filter-elem">
				<div class="col-xs-6 col-sm-4">
					<input type="checkbox" id="document" v-model="filters.find(x => x.id === 'document').value">
					<label for="document">Не доставлено в СЭД. Номер не присвоен.</label>
				</div>
				<div class="col-xs-6 col-sm-4">
					<input type="checkbox" id="esia" v-model="filters.find(x => x.id === 'esia').value">
					<label for="esia">От зарегистрированных в ЕСИА.</label>
				</div>
			</div>

			<button @click="() => getPage()" class="btn blue">Применить</button>
		</div>
		<b>Полный список.</b><br>
		<div class="convertion__count">
			Всего записей:
			<strong>
				{{ meta.total }}
			</strong>
		</div>

		<PagesApp :links="meta.links" class="pages" :click="getPage" />
		<div v-if="appeals.length === 0">
			<b>Нет записей</b>
		</div>
		<template v-else>
			<div class="convertion__elem" v-for="item in appeals" :key="item.uid">
				<AppealItem :item="item" />
			</div>
		</template>
	</div>
</template>

<script>
import { getDataWithToken, getDataJson } from '@/api/getData'
import getStatus from '@/functions/getStatus'
import AppealItem from '@/components/AppealItem.vue'
import { getConfig } from '@/auth'
import PagesApp from '@/components/PagesApp.vue'

const directories = getConfig().directories

export default {
	components: { AppealItem, PagesApp },
	data() {
		return {
			appeals: [],
			error: '',
			links: {},
			meta: {},
			per_page: 50,
			zones: [],
			user: '',
			status_types: [],
			filters: [
				{
					name: 'По исходящему №',
					id: 'uid',
					value: '',
				},
				{
					name: 'По номеру в МСЭД:',
					id: 'registered_number',
					value: '',
				},
				{
					name: 'По IP адресу:',
					id: 'ip',
					value: '',
				},
				{
					name: 'По ФИО:',
					id: 'full_name',
					value: '',
				},
				{
					name: 'По EMail отправителя',
					id: 'email',
					value: '',
				},
				{
					name: 'По теме обращения',
					id: 'theme',
					value: '',
				},
				{
					id: 'created_by_registrar',
					value: null
				},
				{
					id: 'zone_id',
					value: null
				},
				{
					id: 'document',
					value: null
				},
				{
					id: 'esia',
					value: null
				},
				{
					id: 'status_type_id',
					value: null
				},
			]
		}
	},
	created() {
		this.getPage()

		getDataJson(directories.zones).then(zones =>
			this.zones = zones.data
		)
		getDataJson(directories.status_types).then(status_types =>
			this.status_types = status_types.data
		)
	},
	methods: {
		getPage: function (url) {
			url = (url ?? getConfig().appealsAdminUrl + '?page=1') + `&per_page=${this.per_page}`

			this.filters.forEach(filter => {
				if (filter.id === 'document') {
					if (filter.value) url += `&filter[${filter.id}]=${!filter.value}`
				} else if (filter.id === 'esia') {
					if (filter.value) url += `&filter[${filter.id}]=${filter.value}`
				} else {
					url += (filter.value !== null && filter.value !== '') ? `&filter[${filter.id}]=${filter.value}` : ''
				}
			})

			getDataWithToken(url).then(x => {
				this.appeals = x.data.map(x => {
					let y = { ...x }
					y.fio = `${x.last_name ?? ''} ${x.first_name ?? ''} ${x.middle_name ?? ''}`
					y.zone_name = x.zone.name
					y.date_ip = new Date(x.date).toLocaleDateString();
					y.eds_date_local = x.eds_date ? new Date(x.eds_date).toLocaleDateString() : '';
					y.status_desc = getStatus(x?.status_type?.msed_id)

					return y
				})
				this.links = x.links
				this.meta = x.meta
			})
		}
	}
}

</script>